import {Component, ViewChild, ElementRef, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {regexConst} from '@shared/consts/regex.const';
import {environment} from '@env/environment';
import {VendorIntegrationService} from '@shared/services/vendor-integration.service';
import {TelemetryEventName} from '@shared/enums';
import {TelemetryService} from '@shared/services/telemetry-service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CONSTANTS} from "@shared/consts/platform-constants";
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

@UntilDestroy()
@Component({
    selector: 'app-prelogin-access-modal',
    templateUrl: './prelogin-access-modal.component.html',
    styleUrl: './prelogin-access-modal.component.scss',
    standalone: false
})
export class PreloginAccessModalComponent implements OnInit {
  public emailCtrl = new FormControl('', [Validators.required, Validators.pattern(regexConst.EMAIL)]);

  @ViewChild('formRef') formRef: ElementRef<any>;

  constructor(
    private readonly vendorIntegrationService: VendorIntegrationService,
    private readonly telemetryService: TelemetryService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit() {
      this.telemetryService.sendHeapEvent(TelemetryEventName.EVENT_HEAP_METERED_ACCESS_MODAL_OPENED)
        .subscribe();
  }

  onSubmit(): void {
    const username = this.emailCtrl.value;
    if (username) {
      const url = new URL(window.location.href);
      const queryParams = { ...this.route.snapshot.queryParams, username: username };
      const fragment = this.route.snapshot.fragment;
      const path = url.pathname;
      const newUrl = path.replace('/public', ''); // Remove 'public' from the path
      const navigationExtras: NavigationExtras = {
        queryParams,
        fragment
      };
      this.router.navigate([newUrl], navigationExtras);
    }
  }

  onReadFullVersion() {
    this.emailCtrl.markAsTouched();
    if (this.emailCtrl.valid) {
      this.vendorIntegrationService.submitPardotForm(environment.pardotForms.fullAccessForm, {
        username: this.emailCtrl.value,
      })
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            this.submitForm();
          },
          error: () => {
            this.submitForm();
          }
        });
    }
  }

  private submitForm() {
    this.telemetryService.sendHeapEvent(TelemetryEventName.EVENT_HEAP_METERED_ACCESS_EMAIL_SUBMIT, {
      email: this.emailCtrl.value,
    }).subscribe(() => {
      setTimeout(() => {
        this.formRef.nativeElement.submit();
        /* A 2000 ms delay is added to ensure the heap call is processed before redirecting the user to the login page.
        This delay is necessary because we lack a proper heap library to control requests using RxJS. */
      }, CONSTANTS.HEAP_REQUEST_TIMEOUT);
    });
  }
}
